// // TechSpecs.js (modified to accept `product` prop)
// import React from "react";
// import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
// import logo from "../images/Helix logo.jpg";

// // Icons
// import webIcon from "../images/web.jpg";
// import phoneIcon from "../images/phone icon.jpg";
// import locationIcon from "../images/location icon.jpg";
// import messageIcon from "../images/message.jpg";

// const TechSpecs = ({ product = {} }) => {
//   // create rows from product fields (fallback to '-' when empty)
//  const rows = [
//   ["Model No", product.modelNo ?? "-"],
//   ["Pit No", product.pitNo ?? "-"],
//   ["Pit Size", product.pitSize ?? "-"],
//   ["Rated capacity", product.ratedCapacity ?? "-"],
//   ["Length", product.length ?? "-"],
//   ["Width", product.width ?? "-"],
//   ["Structure", product.structure ?? "-"],
//   ["Conveyor Made of", product.conveyorMadeOf ?? "-"],
//   ["Type", product.type ?? "-"],
//   ["Speed", product.speed ?? "-"],
//   ["Gear Motor", product.gearMotorSpec ?? "-"],
//   ["VFD", product.vfd ?? "-"],
//   ["Electric Panel", product.electricPanel ?? "-"],
//   ["Safety Sensors", product.safetySensors ?? "-"],
//   ["Human Sensor", product.humanSensor ?? "-"],
//   ["Buzzer", product.buzzer ?? "-"],
//   ["Operation", product.operation ?? "-"],
//   ["Emergency", product.emergency ?? "-"],
//   ["Wiring", product.wiring ?? "-"],
//   ["Over Load Protection", product.overloadProtection ?? "-"],
//   ["Gear Motor (Notes)", product.gearMotorNotes ?? "-"],
//   ["Panel", product.panel ?? "-"],
//   ["Bearings", product.bearings ?? "-"],
// ];


//   return (
//     <Page size="A4" style={styles.page}>
//       {/* Header */}
//       <View style={styles.header}>
//         <Image src={logo} style={styles.logo} />
//         <View style={styles.headerRight}>
//           <Image src={webIcon} style={styles.iconSmall} />
//           <Text style={styles.website}>
//             {product.website || "sbsgroups.co.in"}
//           </Text>
//         </View>
//       </View>

//       {/* Title */}
//       <Text style={styles.title}>
//         {product.modelNo || product.productName || "Technical Specification"}{" "}
//         {product.pitNo ? `for Pit ${product.pitNo}` : ""}
//       </Text>

//       {/* Specification Table */}
//       <View style={styles.table}>
//         {rows.map(([label, value], i) => (
//           <View key={i} style={styles.row}>
//             <Text style={styles.cellLabel}>{label}</Text>
//             <Text style={styles.cellValue}>{value}</Text>
//           </View>
//         ))}
//       </View>

//       {/* Footer */}
//       <View style={styles.footer}>
//         {/* Phone section */}
//         <View style={styles.footerSection}>
//           <Image src={phoneIcon} style={styles.icon} />
//           <View>
//             {(product.phones || []).slice(0, 2).map((p, idx) => (
//               <Text key={idx} style={styles.footerText}>
//                 {p}
//               </Text>
//             ))}
//           </View>
//         </View>

//         {/* Location section */}
//         <View style={[styles.footerSection, styles.footerCenter]}>
//           <Image src={locationIcon} style={styles.icon} />
//           <Text style={styles.footerText}>
//             {product.address ||
//               "Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA)."}
//           </Text>
//         </View>

//         {/* Message section */}
//         <View style={[styles.footerSection, styles.footerRight]}>
//           <Image src={messageIcon} style={styles.icon} />
//           <View>
//             {(product.emails || []).slice(0, 2).map((e, idx) => (
//               <Text key={idx} style={styles.footerText}>
//                 {e}
//               </Text>
//             ))}
//           </View>
//         </View>
//       </View>
//     </Page>
//   );
// };

// const styles = StyleSheet.create({
//   page: {
//     padding: 25,
//     fontSize: 9,
//     fontFamily: "Helvetica",
//     backgroundColor: "#fff",
//     flexDirection: "column",
//     justifyContent: "space-between",
//   },
//   header: {
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//     borderBottom: "2pt solid #b20000",
//     paddingBottom: 6,
//     marginBottom: 12,
//   },
//   logo: { width: 80, height: 80 },
//   headerRight: { flexDirection: "row", alignItems: "center" },
//   website: {
//     fontSize: 11,
//     color: "#b20000",
//     fontWeight: "bold",
//     marginLeft: 5,
//   },
//   title: {
//     textAlign: "center",
//     fontSize: 12,
//     fontWeight: "bold",
//     marginVertical: 10,
//   },
//   table: { border: "1pt solid #000" },
//   row: { flexDirection: "row", borderBottom: "1pt solid #000" },
//   cellLabel: {
//     width: "40%",
//     padding: 5,
//     borderRight: "1pt solid #000",
//     fontWeight: "bold",
//   },
//   cellValue: { width: "60%", padding: 5 },
//   footer: {
//     flexDirection: "row",
//     backgroundColor: "#b20000",
//     color: "#fff",
//     padding: 8,
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   footerSection: { flexDirection: "row", alignItems: "center", width: "30%" },
//   footerCenter: { width: "40%", textAlign: "center" },
//   footerRight: { justifyContent: "flex-end", textAlign: "right" },
//   footerText: { fontSize: 9, marginLeft: 4, color: "#fff" },
//   icon: { width: 30, height: 30, marginRight: 4 },
//   iconSmall: { width: 30, height: 30, marginRight: 3 },
// });

// export default TechSpecs;



// TechSpecs.js

import React from "react";
import { Page, Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import logo from "../../../../images/Final-logo-SBS.png"

// Icons
import webIcon from "../../images/web.jpg";
import phoneIcon from "../../images/phone icon.jpg";
import locationIcon from "../../images/location icon.jpg";
import messageIcon from "../../images/message.jpg";

const TechSpecs = ({ products = [] }) => {
  console.log("TechSpecs received products:", products);

  const generateSpecificationRows = (product, index) => [
    ["Model No", product.product_name || "N/A"],
    ["Main Category", product.maincategory_name || "N/A"],
    ["Sub Category", product.subcategory_name || "N/A"],
    ["Product ID", product.product_id || "N/A"],
    ["Batch Number", product.batch || "N/A"],
    ["Description", product.description || "N/A"],
    ["Size", product.size || "N/A"],
    ["HSN Code", product.hsncode || "N/A"],
    
  ];

  // Render each product as a new page
  const renderProductPages = () => {
    if (!products || !Array.isArray(products) || products.length === 0) {
      return (
        <Page size="A4" style={styles.page}>
          {renderHeader()}
          <Text style={styles.title}>No Product Specifications Available</Text>
          {renderFooter()}
        </Page>
      );
    }

    return products.map((product, index) => (
      <Page key={product.id || index} size="A4" style={styles.page}>
        {renderHeader()}

        <Text style={styles.title}>
          Technical Specifications for {product.product_name || `Product ${index + 1}`}
        </Text>

        {/* Table */}
        <View style={styles.table}>
          {generateSpecificationRows(product, index).map(([label, value], i) => (
            <View key={i} style={styles.row}>
              <Text style={styles.cellLabel}>{label}</Text>
              <Text style={styles.cellValue}>{value}</Text>
            </View>
          ))}
        </View>

        {/* Page number */}
        <Text style={styles.pageNumber}>
          Product {index + 1} of {products.length}
        </Text>

        {renderFooter()}
      </Page>
    ));
  };

  const renderHeader = () => (
    <View style={styles.header}>
      <Image src={logo} style={styles.logo} />
      <View style={styles.headerRight}>
        <Image src={webIcon} style={styles.iconSmall} />
        <Text style={styles.website}>sbsgroups.co.in</Text>
      </View>
    </View>
  );

  const renderFooter = () => (
    <View style={styles.footer}>
      <View style={styles.footerSection}>
        <Image src={phoneIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>+91 8827559628</Text>
          <Text style={styles.footerText}>+91 9826808412</Text>
        </View>
      </View>

      <View style={[styles.footerSection, styles.footerCenter]}>
        <Image src={locationIcon} style={styles.icon} />
        <Text style={styles.footerText}>
          Main Road Tali Waidhan, Near Honda Showroom, Singrauli M.P.-486886 (INDIA).
        </Text>
      </View>

      <View style={[styles.footerSection, styles.footerRight]}>
        <Image src={messageIcon} style={styles.icon} />
        <View>
          <Text style={styles.footerText}>info@sbsgroups.co.in</Text>
          <Text style={styles.footerText}>sales@sbsgroups.co.in</Text>
        </View>
      </View>
    </View>
  );

  return <>{renderProductPages()}</>;
};

const styles = StyleSheet.create({
  page: {
    padding: 25,
    fontSize: 9,
    fontFamily: "Helvetica",
    backgroundColor: "#fff",
    flexDirection: "column",
    justifyContent: "space-between",
    position: "relative",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2pt solid #b20000",
    paddingBottom: 6,
    marginBottom: 12,
  },
  logo: { width: 80, height: 80 },
  headerRight: { flexDirection: "row", alignItems: "center" },
  website: { fontSize: 11, color: "#b20000", fontWeight: "bold", marginLeft: 5 },
  title: {
    textAlign: "center",
    fontSize: 12,
    fontWeight: "bold",
    marginVertical: 10,
  },
  table: { border: "1pt solid #000", marginBottom: 15 },
  row: { flexDirection: "row", borderBottom: "1pt solid #000" },
  cellLabel: {
    width: "40%",
    padding: 5,
    borderRight: "1pt solid #000",
    fontWeight: "bold",
  },
  cellValue: { width: "60%", padding: 5 },
  pageNumber: {
    position: "absolute",
    bottom: 40,
    right: 25,
    fontSize: 8,
    color: "#666",
  },
  footer: {
    flexDirection: "row",
    backgroundColor: "#b20000",
    color: "#fff",
    padding: 8,
    justifyContent: "space-between",
    alignItems: "center",
  },
  footerSection: { flexDirection: "row", alignItems: "center", width: "30%" },
  footerCenter: { width: "40%", textAlign: "center" },
  footerRight: { justifyContent: "flex-end", textAlign: "right" },
  footerText: { fontSize: 9, marginLeft: 4, color: "#fff" },
  icon: { width: 30, height: 30, marginRight: 4 },
  iconSmall: { width: 30, height: 30, marginRight: 3 },
});

export default TechSpecs;